import { Box } from '@chakra-ui/react';
import React, { useEffect } from 'react';
import './HubspotContactForm.css';

interface hubspotContactFormProps {
    region: string;
    portalId: string;
    formId: string;
}

declare global {
    interface Window {
        hbspt: any;
    }
}

const HubspotContactForm = ({ region, portalId, formId }: hubspotContactFormProps) => {
    useEffect(() => {
        const script = document.createElement('script');
        script.src = 'https://js.hsforms.net/forms/shell.js';
        document.body.appendChild(script);

        script.addEventListener('load', () => {
            // @TS-ignore
            if (window.hbspt) {
                // @TS-ignore
                window.hbspt.forms.create({
                    region: region,
                    portalId: portalId,
                    formId: formId,
                    target: '#hubspotForm',
                });
            }
        });
    }, []);

    return (
        <Box px={{ base: '0', lg: '50px' }}>
            <div id="hubspotForm"></div>
        </Box>
    );
};

export default HubspotContactForm;
